import React, { useEffect } from "react";
import styled from "styled-components";
import SVGButton from "../Buttons/SVGButton";
import deleteIcon from "../../Images/Delete.svg";
import { useLanguage } from "../../Components/LangTranslation/LanguageContext";
import { useFormikContext } from "formik";
import FormikSelect from "../Formik/FormikSelect";
import FormikInput from "../Formik/FormikInput";
import { TABLE_CELL_INPUT_MINIMUM_WIDTH } from "../../utilities/constants";
import { getTotalTaxAndAmountADDSaleOrder } from "../../utilities/functions";
import { useSession } from "../../authentications/SessionContext";
const TableContainer = styled.div`
  width: 100%;
  background-color: #fff;
  border-radius: 15px;
  padding: 13px;
`;

const Button = styled.button`
  background-color: #fff;
  color: #ff5837;
  border: none;
  font-weight: 600;
  width: 130px;
  min-width: 150px;
  height: 40px;
  margin-right: 110px;
  outline: none; /* Remove default button outline */
`;

const Orderlines = ({
  keyName,
  productList,
  handleChangeProduct,
  handleSearch,
  disabled,
  taxList,
  isLoadingChange,
}) => {
  const { sessionInfo } = useSession();
  const { company_id } = sessionInfo;

  const { language, translations } = useLanguage();
  const t = translations[language];

  const { values, setFieldValue } = useFormikContext();

  const addRow = () => {
    const newRow = {
      product_id: "",
      name: "",
      product_uom_qty: 1,
      price_unit: 0,
      tax_id: "",
      discount: 0,
      price_total: 0,
    };
    setFieldValue(keyName, [...values[keyName], newRow]);
  };

  const removeRow = (index) => {
    const newRows = [...values[keyName]];
    newRows.splice(index, 1);
    setFieldValue(keyName, newRows);
  };

  const handleChangeProductId = (option, e, index) => {
    handleChangeProduct({
      option,
      index,
      setFieldValue,
      keyName,
      values: values[keyName][index],
    });
  };
  const handleChangeProductLine = (option, index, newValues) => {
    handleChangeProduct({
      option,
      index,
      setFieldValue,
      keyName,
      values: { ...(values?.[keyName]?.[index] || {}), ...newValues },
    });
  };
  // useEffect(() => {
  //   if (values?.[keyName]?.length > 0) {
  //     values?.[keyName]?.forEach((item, index) => {
  //       const { totalAmount } = getTotalTaxAndAmountADDSaleOrder([item]);
  //       setFieldValue(`${keyName}.${index}.price_total`, totalAmount);
  //     });
  //   }
  // }, [values]);
  return (
    <>
      <TableContainer>
        <table className="table">
          <thead>
            <tr>
              <th style={{ minWidth: TABLE_CELL_INPUT_MINIMUM_WIDTH }}>
                {t["Product"]}
              </th>
              <th style={{ minWidth: TABLE_CELL_INPUT_MINIMUM_WIDTH }}>
                {t["Description"]}
              </th>
              <th style={{ minWidth: TABLE_CELL_INPUT_MINIMUM_WIDTH }}>
                {t["Quantity"]}
              </th>
              <th style={{ minWidth: TABLE_CELL_INPUT_MINIMUM_WIDTH }}>
                {t["Unit Price"]}
              </th>
              <th style={{ minWidth: TABLE_CELL_INPUT_MINIMUM_WIDTH }}>
                {t["Tax%"]}
              </th>
              <th style={{ minWidth: TABLE_CELL_INPUT_MINIMUM_WIDTH }}>
                {t["Discount"]}
              </th>
              <th style={{ minWidth: TABLE_CELL_INPUT_MINIMUM_WIDTH }}>
                {t["Total"]}
              </th>
              {!disabled && <th>Action</th>}
            </tr>
          </thead>
          <tbody>
            {values?.[keyName]?.map((row, index) => (
              <tr key={index}>
                <td>
                  <FormikSelect
                    disabled={disabled}
                    menuPosition="fixed"
                    name={`${keyName}.${index}.product_id`}
                    options={productList}
                    handleSearch={({ ...args }) => {
                      handleSearch({
                        ...args,
                        model: "product.product",
                        args: [
                          ["sale_ok", "=", true],
                          "|",
                          ["company_id", "!=", false],
                          ["company_id", "=", company_id],
                        ],
                      });
                    }}
                    // handleSearch={(...args)=>handleSearch(...args,'product.product')}
                    onChange={(option, e) =>
                      handleChangeProductId(option, e, index)
                    }
                  />
                </td>
                <td>
                  <FormikInput
                    name={`${keyName}.${index}.name`}
                    disabled={disabled}
                  />
                </td>
                <td>
                  <FormikInput
                    name={`${keyName}.${index}.product_uom_qty`}
                    type="number"
                    disabled={disabled}
                    onChange={(e) =>
                      handleChangeProductLine(
                        { value: row.product_id, label: row.name },
                        index,
                        {
                          product_uom_qty: e.target.value,
                        }
                      )
                    }
                  />
                </td>
                <td>
                  <FormikInput
                    name={`${keyName}.${index}.price_unit`}
                    type="number"
                    disabled={disabled}
                    onChange={(e) =>
                      handleChangeProductLine(
                        { value: row.product_id, label: row.name },
                        index,
                        {
                          price_unit: e.target.value,
                        }
                      )
                    }
                  />
                </td>
                <td>
                  <FormikSelect
                    name={`${keyName}.${index}.tax_id`}
                    menuPosition="fixed"
                    options={taxList}
                    disabled={disabled}
                    onChange={(option) =>
                      handleChangeProductLine(
                        { value: row.product_id, label: row.name },
                        index,
                        {
                          tax_id: option.value,
                        }
                      )
                    }
                  />
                </td>
                <td>
                  <FormikInput
                    name={`${keyName}.${index}.discount`}
                    type="number"
                    disabled={disabled}
                    onChange={(e) =>
                      handleChangeProductLine(
                        { value: row.product_id, label: row.name },
                        index,
                        {
                          discount: e.target.value,
                        }
                      )
                    }
                  />
                </td>
                <td>
                  <FormikInput
                    name={`${keyName}.${index}.price_total`}
                    type="number"
                    disabled={true}
                  />
                </td>
                {!disabled && (
                  <td className="d-flex justify-content-center align-items-center ">
                    {isLoadingChange === index ? (
                      <div
                        className="loader mt-3"
                        style={{ height: 25, width: 25, borderWidth: 5 }}
                      />
                    ) : (
                      <SVGButton
                        disabled={disabled}
                        onClick={() => removeRow(index)}
                        icon={deleteIcon}
                        hoverColor="silver"
                      />
                    )}
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </TableContainer>
      {!disabled && (
        <Button role="button" type="button" onClick={addRow}>
          + {t["Add a Product"]}
        </Button>
      )}
    </>
  );
};

export default Orderlines;
